import { render, staticRenderFns } from "./faceUpload.vue?vue&type=template&id=3f1d262d&scoped=true&"
import script from "./faceUpload.vue?vue&type=script&lang=js&"
export * from "./faceUpload.vue?vue&type=script&lang=js&"
import style0 from "./faceUpload.vue?vue&type=style&index=0&id=3f1d262d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1d262d",
  null
  
)

export default component.exports